export function IsExpressionSpecification(value) {
    return Array.isArray(value) && typeof value[0] === "string";
}
export var LayerStyleTypes;
(function (LayerStyleTypes) {
    LayerStyleTypes["Fill"] = "fill";
    LayerStyleTypes["Line"] = "line";
    LayerStyleTypes["Circle"] = "circle";
    LayerStyleTypes["Background"] = "background";
})(LayerStyleTypes || (LayerStyleTypes = {}));
export function IsFillLayerStyle(value) {
    return value && value.type === LayerStyleTypes.Fill;
}
export function IsLineLayerStyle(value) {
    return value && value.type === LayerStyleTypes.Line;
}
//# sourceMappingURL=tiles.vector.style.interface.js.map